<prox-main [parent]="this" [bodyTemplate]="bodyTemplate"></prox-main>
<ng-template #bodyTemplate>
  <div class="qb-list-actions">
    <p-button (onClick)="onAddMessage()" label="Add Message" icon="pi pi-plus" size="small"></p-button>
    <p-button (onClick)="onAdd()" label="Add Notification" icon="pi pi-plus" size="small"></p-button>
    <p-button (onClick)="onAdd()" label="Add Custom Action" icon="pi pi-plus" size="small"></p-button>
  </div>
  <div class="qb-layout-grid">
    <prox-ag-grid [gridOptions]="gridOptions" [rowData]="actions"></prox-ag-grid>
  </div>
</ng-template>